import { network } from 'services/network';

export const getActivityLevelDriversTornadoChart = (params: Params) => {
    return network.post<Response>('api/bo/getActivityLevelDriversTornadoChart', params).then((response) => {
        return response.data;
    });
};

interface Params {
    metaDataId: number;
    numOfIterations: number;
    riskIds: number[];
    taskVersionHashCode: string;
}

export interface Response {
    tornadoResponse: {
        impactType: string;
        targetActivityId: string;
        targetActivityName: string;
        tornadoActivities: {
            activityId: string;
            activityName: string;
            impactValue: number;
        }[];
    }[];
}
